<template>
  <!-- priceConfiguration 单价配置 -->
  <div class="flexBetween" style="display: flex;">
    <div class="tabsContainer">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="电表" name="first">电表</el-tab-pane>
      </el-tabs>
      <div class="tabHeader">
        <span v-for="tab in tabList" :key="'tab'+tab.value" :class="{'tabAct':nowTab == tab.value}"
          @click="nowTab = tab.value">{{tab.name}}</span>
      </div>
      <div v-show="nowTab == 0" class="custom-scrollbar tabBody" style="height: calc(100% - 32px);">
        <div class="chargingDetailLi" v-for="single in listData" :key="'single'+single.id">
          <p class="chargingTitle">计费名称： {{single.name}}</p>
          <p class="chargingPrice">时间:{{single.year+'-'+single.month}}</p>
          <!-- <div class="line"></div> -->
          <div class="chargingOperate">
            <span @click="editChargeMode(single)">编辑</span>
            <el-popconfirm title="确定要删除此单价计费吗？" @onConfirm="deleteChargeMode(single)">
              <span slot="reference">删除</span>
            </el-popconfirm>
            <!-- <span @click="deleteChargeMode(single)">删除</span> -->
          </div>
        </div>
        <div class="addNewCharging" style="height: 145px;">
          <img @click="addSingleCharge"
            :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
        </div>
      </div>


    </div>

    <AddNewChargingDialog ref="addNewCharging"></AddNewChargingDialog>


    <PeakAndValleyBillingViewDialog ref="peakAndValleyBillingViewDialog"></PeakAndValleyBillingViewDialog>
  </div>
</template>

<script>
  import AddNewChargingDialog from './dialogs/AddNewChargingDialog1.vue'
  import PeakAndValleyBillingViewDialog from './dialogs/PeakAndValleyBillingViewDialog.vue'
  import meterManagerStore from './meterManagerStore.js'
  import request from "@/api/http.js";
  export default {
    components: {
      AddNewChargingDialog,
      PeakAndValleyBillingViewDialog
    },
    props: {},
    data () {
      return {
        nowTab: 0,
        tabList: [{name: '单价计费',value: 0}],
        activeName: 'first',
        listData: [],//数据
        nowUnitInfo: {}
      }
    },
    mounted () {
      this.ceshi()
      // meterManagerStore.commit("setNowUser",this.nowUser)
      // meterManagerStore.commit("setNowUnit",{
      //   unit: this.nowUnit,activeName: this.activeName
      // })
    },
    computed: {
      nowUser () {
        return this.$store.userStore.state.nowUserInfo
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
    },
    watch: {
      nowUser (nv,ov) {
        meterManagerStore.commit("setNowUser",nv)
      }
    },
    methods: {
      ceshi () {
        var data={
          unitId: this.nowUnit.id,activeName: this.activeName
        }
        var data=new FormData();
        data.append("unitId",this.nowUnit.id);
        data.append("activeName",this.activeName);
        request({url: "/meterReading/getAllMeterBillingMode1.do",method: "post",data}).then(res => {
          if(res.success) {
            this.listData=res.data.StepBilling
          }
        })
      },
      handleClick (tab,event) {
        if(this.activeName=='second') {

          this.nowTab=3;
          this.tabList=[{name: '单价计费',value: 3},{name: '阶梯计费',value: 4}];

        } else {
          this.nowTab=0;
          this.tabList=[{name: '单价计费',value: 0},{name: '阶梯计费',value: 1},{name: '费率计费',value: 2}];
        }

        meterManagerStore.commit("setNowUnit",{
          unit: this.nowUnit,activeName: this.activeName
        })
      },
      saveUnitInfo () {

      },
      addSingleCharge () {
        this.$refs.addNewCharging.open('新增单价计费','single',this.activeName,{},result => {
          this.saveChargeMode(result)
        })
      },



      // 保存计费方式
      saveChargeMode (e) {
        var data=new FormData();
        for(const key in e) {
          data.append(key,e[key]);
        }
        data.append('activeName',this.activeName);
        request({url: "/meterReading/saveMeterBillingMode1.do",method: "post",data}).then(res => {
          console.log(res,'12');
          if(res.success) {
            this.$dialogMethod.showMessage('保存成功');
            this.ceshi()
          } else {
            this.$dialogMethod.showMessage('保存失败')
          }
        })

        // this.$api.meterReadingApi.saveMeterBillingMode(data.pkid,data.name,this.activeName,data.billingMode,data.deductionStandard,this.nowUnit.id,respon => {
        //   this.$dialogMethod.showMessage('保存成功')
        //   meterManagerStore.commit('getAllMeterBillingMode',{
        //     unitId: this.nowUnit.id,activeName: this.activeName
        //   })
        // },err => {
        //   this.$dialogMethod.showMessage('保存失败')
        // })
      },

      // 删除计费方式
      deleteChargeMode (item) {
        this.$api.meterReadingApi.deleteMeterBillingMode(item.pkid,respon => {
          this.$dialogMethod.showMessage(respon)
          meterManagerStore.commit('getAllMeterBillingMode',{
            unitId: this.nowUnit.id,activeName: this.activeName
          })
        },err => {
          this.$dialogMethod.showMessage(err)
        })
      },
      // 编辑计费方式
      editChargeMode (item) {
        this.$refs.addNewCharging.open('编辑单价计费','single',this.activeName,item,result => {
          this.saveChargeMode(result)
        })
      },
      // 查看费率计费详情
      viewDetails (item) {
        this.$refs.peakAndValleyBillingViewDialog.open(copy(item))
      }
    }
  }
</script>

<style scoped>
  .tabsContainer {
    width: calc(100% - 40px);
    padding: 20px;
    height: calc(100% - 40px);
    background: #FFFFFF;
  }

  .chargingDetailLi {
    width: calc((100% - 176px) / 6.5);
    /* border-bottom: solid 1px #E4E4E4; */
    border-radius: 6px;
    margin: 30px 10px 0 10px;
    /* text-align: center; */
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 4px 8px 0px #e8eff5;

  }

  .chargingDetailLi2 {
    width: calc((100% - 176px) / 5);
  }

  .chargingDetailLi3 {
    width: calc((100% - 176px) / 10);
  }

  .chargingTitle {
    line-height: 45px;
    /* background-color: #F2F2F2; */
    background-color: #DBEDFF;
    /* margin-left: 12px; */
    padding-left: 12px;
    color: #3E9AF8;
    margin-bottom: 10px;


    /* border-bottom: solid 1px #E4E4E4; */
    /* border-bottom: solid 1px #DBEDFF; */
  }

  .chargingPrice {
    line-height: 45px;
    padding-left: 12px;
    color: #1A1A1A;

  }

  .line {
    /* width: calc(100% -0.24rem); */

    width: calc(100% - 0.24rem);
    height: .01rem;
    background-color: #E4E4E4;
    margin-left: .12rem;
  }

  .chargingDetails {
    padding: 0 10px;
  }

  .chargingDetails>p {
    line-height: 0.36rem;
    text-align: left;
    /* color: #919191; */
    color: #1A1A1A;
    /* border-bottom: solid 1px #E4E4E4; */
  }

  .chargingDetails>p:last-child {
    border-bottom: none;
  }

  .chargingDetails>p>span {
    color: #919191;
    color: #1A1A1A;
  }

  .chargingOperate {

    text-align: right;
  }

  .chargingOperate>span {
    display: inline-block;
    line-height: 45px;
    cursor: pointer;
    /* width: calc(50% - 0.5px); */
  }

  .chargingOperate>span:first-child {
    /* border-right: solid 1px #E4E4E4; */
    color: #3E9AF8;
    /* margin-right: 12px; */
  }

  .chargingOperate>span:last-child {
    color: #FF7765;
    margin: 0 12px;
  }

  .addNewCharging {
    display: flex;
    width: calc((100% - 176px) / 8);
    margin: 30px 10px 0 10px;
    align-items: center;
    justify-content: center;
  }

  .addNewCharging>img {

    cursor: pointer;
  }

  .tabHeader {
    border-bottom: solid 1px #E4E4E4;
  }

  .tabHeader>span {
    display: inline-block;
    margin-right: 30px;
    line-height: 30px;
    position: relative;
    top: 1px;
    cursor: pointer;
  }

  .tabAct {
    color: #409EFF;
    border-bottom: solid 1px #409EFF;
  }

  .tabBody {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 1600px) {
    .chargingDetailLi {
      width: calc((100% - 154px) / 7);
    }

    .addNewCharging {
      width: calc((100% - 154px) / 7);
    }
  }

  @media screen and (max-width: 1650px) {
    .chargingDetailLi {
      width: calc((100% - 132px) / 6);
    }

    .addNewCharging {
      width: calc((100% - 132px) / 6);
    }
  }
</style>